import React from "react";
import { useTranslation } from "react-i18next";

export default function HaGetProfileById() {
  const { t } = useTranslation("help");

  return (
    <div className="endpoint-container">
      <a href="#get-profile-by-id" className="endpoint-title">
        {t("HaGetProfileById.title", "Get Profile by ID")}
      </a>

      <pre className="code-block">
        <code>{`import requests

API_KEY = ""  # ${t("HaGetProfileById.required", "Required")}
SESSION_KEY = ""  # ${t("HaGetProfileById.required", "Required")}
PROFILE_ID = ""  # ${t("HaGetProfileById.required", "Required")}

url = f"https://demo.whitehax.com/api/profiles-config/getProfileById/{PROFILE_ID}"

headers = {"Authorization": API_KEY, "X-Session-Key": SESSION_KEY}

response = requests.request("GET", url, headers=headers)

print(response.text)`}</code>
      </pre>

      <style>{`
        .endpoint-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 0;
          font-family: Arial, Helvetica, sans-serif;
        }

        .endpoint-title {
          display: inline-block;
          margin-bottom: 26px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }

        .endpoint-title:hover {
          color: #b7ddf2;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          overflow-x: auto;
          tab-size: 4;
        }

        .code-block code {
          font-family: inherit;
        }

        @media (max-width: 768px) {
          .endpoint-title {
            font-size: 15px;
            margin-bottom: 20px;
          }

          .code-block {
            font-size: 13px;
            line-height: 1.45;
            overflow-x: auto;
          }
        }
      `}</style>
    </div>
  );
}